import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import logo4 from "../../assets/images/logos/4.png";
import icb from '../../assets/images/logos/icb-logo-02.png'
import LanguageComponent from '../../common/components/language/languageComponent';
import { NavLink } from "react-router-dom";
import { withRouter } from "react-router-dom";
import Translate from '../../common/translate';
import { connect } from 'react-redux';

const routes = [
  { path: '/', name: 'Main Scene' },
  { path: '/main-hall', name: 'Main Hall' },
  { path: '/assembly-line', name: 'Assembly Line' },
  { path: '/entrance', name: 'Innovation Hub' }
];

const getChildRoutes = (location) => {
  switch (location) {
    case '/':
      return routes.filter(r => r.path !== '/' && r.path !== '/assembly-line');
    case '/main-hall':
      return routes.filter(r => r.path === '/assembly-line');
    default:
      return [];
  }
}

const getPreviousRoute = (location) => {
  switch (location) {
    case '/main-hall':
    case '/entrance':
      return routes.filter(r => r.path === '/');
    case '/assembly-line':
      return routes.filter(r => r.path === '/' || r.path === '/main-hall');
    case '/panorama':
      return routes.filter(r => r.path === '/entrance');
    default:
      return [];
  }
}

const MainNavigation = (props) => {
  let newRoutes = getChildRoutes(props.location.pathname);
  let previousRoute = getPreviousRoute(props.location.pathname);
  return (
    <>
      <div className="menu top-left">
        {/* <NavLink exact to="/eco-struxure">
            <FontAwesomeIcon icon={faBars} size="2x" color="#3dcd58" />
          </NavLink> */}
      </div>
      <div className="logo-bottom-right">
        <img src={logo4} width="350px" alt="logo" />
      </div>

      <div className="logo-bottom-left" onClick={() => window.open('https://www.icb.bg')}>
        <a href="https://www.icb.bg" target="_blank" rel="noopener noreferrer">
          <img src={icb} width="170px" alt="logo" />
        </a>
      </div>

      {newRoutes && newRoutes.length > 0 ?
        <div className="main-nav">
          {newRoutes.map((r, indx) => {
            return <NavLink key={indx} exact to={r.path}>
              {Translate(r.name)} <FontAwesomeIcon icon={faChevronRight} className="icon" />
            </NavLink>
          })}
        </div> : null}

      {previousRoute ?
        <div className="submenu">
          {previousRoute.map((r, index) => {
            return <NavLink key={index + 'p'} exact to={r.path}>
              <FontAwesomeIcon icon={faChevronLeft} className="submenu-icon" /> {Translate(r.name)}
            </NavLink>
          })}
        </div>
        : null}

      <LanguageComponent />
    </>
  )
}

const mapsStateToProps = (state: any) => {
  return {
    lang: state.common.lang,
    // animationState: state.common.animationState
  };
}

export default withRouter(connect(mapsStateToProps, null)(MainNavigation));